import { handleInitialRender } from '../redux/application/application'

export default function(context) {
  return context.reduxStore.dispatch(handleInitialRender())
}
